export default __webpack_public_path__ + "static/media/GLOSSARY.e0dad028.pdf";